module.exports = __webpack_public_path__ + "img/冷.76447e81.png";